import { all } from 'redux-saga/effects';
import { watchCognitoRegistering, watchCognitoConfirming, watchUpdateRegistrationState, watchCognitoUserReverify, watchRegisterUserBackend, watchTryAgain, watchcheckUserEmail} from '../registrationSaga';

import { watchInitAssessment,  watchCompleteAssessment, watchSaveSection, watchInitSection, watchLogout} from '../sectionSaga';

export default function* rootSaga() {
  yield all([watchCognitoRegistering(), watchCognitoConfirming(), watchInitAssessment(),  watchCompleteAssessment(), watchSaveSection(), watchUpdateRegistrationState(), watchInitSection(), watchCognitoUserReverify(), watchLogout(), watchRegisterUserBackend(), watchTryAgain(), watchcheckUserEmail()]);
}